"use client";

import { FE_CHEQ_AI_IMPACT_TEST_250326 } from "@faire/retailer-settings/FE_CHEQ_AI_IMPACT_TEST_250326";

import { useAssignSetting } from "./__internal__/useSetting";

export const useAssignSettingCheqAIImpactTest = () =>
  useAssignSetting(FE_CHEQ_AI_IMPACT_TEST_250326);
